(function () {
    'use strict';

    angular
        .module('core.interceptors')
        .factory('authenticationFactory', AuthenticationFactory)

    /** @ngInject */
    function AuthenticationFactory($q, $rootScope, AUTH_EVENTS, LOCAL_STORAGE_ITEMS) {
        return {
            request: request,
            responseError: responseError
        }

        function request(config) {
            const accessToken = localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN);
            const companyId = localStorage.getItem(LOCAL_STORAGE_ITEMS.SELECTED_COMPANY);

            if (accessToken) {
                Object.assign(config.headers, {
                    'Authorization': 'Bearer ' + accessToken,
                    'company_id': companyId
                });
            }

            return config;
        }

        function responseError(response) {
            $rootScope.$broadcast({
                401: AUTH_EVENTS.NOT_AUTHENTICATED
            }[response.status], response);

            return $q.reject(response);
        }
    }
}());